// extracted by mini-css-extract-plugin
export default {"MainHeader__logo":"HeaderLogo_MainHeader__logo__Mhx1a","main_logos_wrap":"HeaderLogo_main_logos_wrap__qrpVi","main_logos_item":"HeaderLogo_main_logos_item__J-rDv"};